<template>
  <div>
    <loading v-if="loading"></loading>
    <div class="storage-switch-detail" v-if="dataPermission.includes('NSH_ODM_TF_VIEW')">
      <LayoutStorage @btnBack="getBtnBack">
        <template v-slot:actions>
        </template>
        <template v-slot:title>
          <span v-if="typeOrder">
            Đơn xuất: {{ exportInfo.orderNo }}
          </span>
          <span v-else>
            Đơn nhập: {{ exportInfo.orderNo }}
          </span>
        </template>
        <template v-slot:content v-if="documentInfo.id">
          <div class="step-status">
            <el-steps :active="step.value" align-center style="padding: 30px 0;">
              <el-step v-for="(action, index) in actionsHistory" :key="index" :title="action.actionName" :icon="action.processorStatus === 'CANCELED' ? 'el-icon-circle-close' : ''" :description="action.modifiedAtDisplay"></el-step>
            </el-steps>
          </div>
          <el-card>
              <div slot="header" class="card-header-ui">
                <span>Thông tin cơ bản</span>
                <el-form :model="documentInfo" :rules="documentInfoRule" label-width="140px">
                  <el-row>
                    <el-col :span="10">
                      <el-form-item label="Mã đơn" prop="orderId">
                        <el-input v-model="exportInfo.orderNo" disabled placeholder="Nhập mã đơn" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10" :offset="4">
                      <el-form-item label="Ngày tạo">
                        <el-input v-model="documentInfo.createdAt" disabled />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="18">
                      <el-form-item label="Lý do chuyển" prop="reason">
                        <el-input v-model="documentInfo.paramsTransfer.reason" disabled placeholder="Nhập lý do" />
                      </el-form-item>
                      <el-form-item label="Mã tham chiếu">
                        <el-input v-model="documentInfo.paramsTransfer.referenceCode" disabled placeholder="Nhập mã tham chiếu" />
                      </el-form-item>
                      <el-form-item label="Ghi chú" prop="note">
                        <el-input type="textarea" maxlength="255" disabled :autosize="{ minRows: 4, maxRows: 10}" v-model="documentInfo.paramsTransfer.note" placeholder="Nhập ghi chú" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
          </el-card>
          <el-card style="margin: 20px 0;">
              <div slot="header" class="card-header-ui">
                <span>Thông tin chuyển kho</span>
              </div>
              <div>
                <el-form :model="documentInfo" :rules="documentInfoRule" label-width="140px">
                  <el-row :gutter="20">
                    <el-col :span="12" :lg="12" :md="12" :xs="24" v-if="typeOrder">
                      <el-form-item label="kho xuất" prop="storageExport">
                        <el-input :value="documentInfo.paramsTransfer.fromInventoryName" disabled />
                      </el-form-item>
                      <el-form-item label="Mã đơn chuyển" prop="locationImport">
                        {{ documentInfo.orderNo }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" :lg="12" :md="12" :xs="24" v-else>
                      <el-form-item label="kho nhập" prop="storageExport">
                        <el-input :value="documentInfo.paramsTransfer.toInventoryName" disabled />
                      </el-form-item>
                      <el-form-item label="Mã đơn chuyển" prop="locationImport">
                        {{ documentInfo.orderNo }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-card>
            <el-card>
              <div slot="header" class="card-header-ui">
                <span>Danh sách sản phẩm</span>
              </div>
              <div>
                <el-input placeholder="Tìm kiếm phiên bản sản phẩm" />
              </div>
              <div class="products-valid">
                <el-table
                  :data="productList"
                  style="width: 100%"
                  row-key="key"
                  :expand-row-keys="expandRowKeys"
                >
                  <el-table-column
                    label="STT"
                    type="index"
                  />
                  <el-table-column type="expand" width="1">
                    <template slot-scope="scope">
                      <div v-if="scope.row.useImeiAndSerial">
                        <strong style="font-weight: bold !important; width: 120px;">Imei/serial: </strong>
                        <el-tag type="info" size="mini" v-for="serie in scope.row.seriesNo" :key="serie" style="margin: 0 3px;">{{ serie }}</el-tag>
                      </div>
                      <div v-if="scope.row.useProductBatch">
                        <base-tag v-for="(batch, index) in scope.row.arrBatchs" :key="index" type="info" style="margin-right: 6px; margin-top: 8px;">
                          {{ batch.batchCode }} - HSD: {{ timeFormatDate(batch.expirationDate) }} - SL: {{ batch.quantity }}
                        </base-tag>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="SKU" prop="sku"/>
                  <el-table-column label="Phiên bản sản phẩm" prop="variation"/>
                  <el-table-column label="Số lượng" prop="quantity"/>
                  <el-table-column label="Đơn vị" prop="unit"/>
                </el-table>
                <div style="float: right; padding: 20px 0; display: flex;">
                  <h5>
                    Số lượng mặt hàng: {{ productList.length }}
                  </h5>
                  <h5 style="padding: 0 20px;">
                    Tổng số lượng: {{ totalQuantity }}
                  </h5>
                </div>
              </div>
            </el-card>
        </template>
      </LayoutStorage>
    </div>
    <NotPermission v-else></NotPermission>
  </div>
  </template>
  
  <script>
  import LayoutStorage from '@/router/layouts/storage.vue'
  import { InventoryService } from "@/services/nextshop/inventory.service.js"
  import { formatHHmmDDMMYYYY } from "@/utils/format";
  import NotPermission from '@/components/not-permission'
  import { API_EXPORT_STORAGE_DETAIL } from '../../../utils/contants';
  import { getInventoryById } from '../../../api/inventory';
  import { statusCheckInStorage } from '../../../utils/mapping';
  import { transferStatus2 } from '@/components/inventory/status-order.js'
  import { getDataPermission } from '../../../utils/auth';
  export default {
    components: {
      LayoutStorage,
      NotPermission
    },
    data() {
      return {
        dataPermission: getDataPermission(),
        documentInfo: {},
        documentInfoRule: {},
        documentID: this.$route.params.documentID,
        loading: false,
        step: {
          value: 0,
          label: 'DRAFT'
        },
        actionsHistory: [],
        fieldProducts: [
          { 
            label: "",
            key: "index"
          },
          { 
            label: "SKU",
            key: "sku"
          },
          { 
            label: "Phiên bản sản phẩm",
            key: "variation"
          },
          { 
            label: "Số lượng",
            key: "quantity"
          },
          { 
            label: "Đơn vị",
            key: "unit"
          },
        ],
        productList: [],
        expandRowKeys: [1],
        totalQuantity: 0,
        totalProduct: 0,
        exportInfo: {},
        typeOrder: false
      }
    },
    computed: {
      allowEdit() {
        // dataPermission.includes('NSH_ODM_TF_UPDATE')
        return this.documentInfo.processorStatus === 'DRAFT'
      }
    },
  
    created() {
      this.getInvenById()
      this.orderExport()
    },
  
    methods: {
      orderExport() {
        const fullPath = this.$route.fullPath
        if (fullPath.includes(API_EXPORT_STORAGE_DETAIL)) {
          this.typeOrder = true
        } else {
          this.typeOrder = false
        }
      },
  
      getBtnBack() {
        this.$router.push('/inventory-checkout')
      },
      getTextAction (key) {
        switch (key) {
          case 'CREATE': return 'Tạo đơn nháp'
          case 'UPDATE': return 'Chỉnh sửa đơn'
          case 'CANCEL': return 'Huỷ đơn'
          case 'COMPLETE_TRANSFER': return 'Xác nhận điều chuyển'
        }
      },
      getInvenById() {
        this.loading = true
        getInventoryById({id: this.documentID}).then(res => {
          this.loading = false
          if (res.code === 'SUCCESS') {
            this.exportInfo = res.data
            this.step = statusCheckInStorage(res.data.orderStatus)
            this.actionsHistory = transferStatus2(res.data.statusHistory, this.typeOrder)
            if (res.data.orderReferenceId) {
              this.getDataDetail(res.data.orderReferenceId)
            }
          }
        })
      },
      async getDataDetail(id) {
        try {
          const params = { id: id }
          const response = await InventoryService.transDetail(id, params)
          if (response.success) {
            const params = response.data.furtherInstructions.find(fur => fur.key === 'TRANSFER' || fur.key === 'SO_ORDER_OPERATION' || fur.key === 'CHECK_OUT')
            const paramsTransfer = params.params
            this.documentInfo = {...response.data, paramsTransfer }
            this.documentInfo.createdAt = formatHHmmDDMMYYYY(this.documentInfo.createdAt)
            const products = []
            response.data.lineItem.forEach((e, index) => {
              const check = products.find(re => re.lineItemId === e.lineItemId)
              if (check) {
                check.quantity += e.quantity
                const productBatch = (e.lineItemOtherInfo.productBatch && e.lineItemOtherInfo.productBatch != '') ? JSON.parse(e.lineItemOtherInfo.productBatch) : {}
                check.arrBatchs.push(productBatch)
              } else {
                const productBatch = (e.lineItemOtherInfo.productBatch && e.lineItemOtherInfo.productBatch != '') ? JSON.parse(e.lineItemOtherInfo.productBatch) : {}
                products.push(
                  {
                    ...e,
                    key: index,
                    sku: e.itemInstance.moreInformation.sku,
                    variation: e.itemInstance.name,
                    quantity: e.quantity,
                    unit: e.unit,
                    seriesNo: (e.lineItemOtherInfo.seriesNo && e.lineItemOtherInfo.seriesNo != null) ? JSON.parse(e.lineItemOtherInfo.seriesNo) : [],
                    arrBatchs: [productBatch],
                    useImeiAndSerial: (e.lineItemOtherInfo?.seriesNo) ? true: false,
                    useProductBatch: (productBatch?.batchCode) ? true : false
                  }
                )
              }
            })
            this.expandRowKeys = products.filter(product => product.useImeiAndSerial || product.useProductBatch).map(pr => pr.key)
            this.productList = products
            // trang thai don
            this.statusActive = response.data.statusHistory.length
            this.totalQuantity = this.productList.map(e => e.quantity)
            .reduce((a, b) => a + b, this.totalQuantity)
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
  </script>
  
  <style>
  .storage-switch-detail .el-step__icon.is-icon i {
    color: red;
    font-size: 35px;
  }
  .storage-switch-detail h5 {
    font-weight: bold !important;
    font-size: 14px !important;
  }
  .storage-switch-detail .el-table__expand-icon{
    display: none;
  }
  </style>
  